import getApi from '../../api'
import { Task, TaskMutationPayload } from '../../model/Task'

export const createTask = (task: TaskMutationPayload) => getApi().post<Task>(`/tasks`, task)
